import dialog from './dialog';
import input from './input';
import alert from './alert';

export const Dialog = function install(Vue, { name = undefined } = {}) {
  Vue.component((name ? name : dialog.name), dialog);
};

export const InputDialog = function install(Vue, { name = undefined } = {}) {
  Vue.component((name ? name : input.name), input);
};

export const Alert = function install(Vue, { name = undefined } = {}) {
  Vue.component((name ? name : alert.name), alert);
};

export default function install(Vue) {
  Vue.component(dialog.name, dialog);
  Vue.component(input.name, input);
  Vue.component(alert.name, alert);
}
